__turbopack_context__.v({
  "expandButton": "ExpandButton-module-scss-module__P0ZRga__expandButton",
  "icon": "ExpandButton-module-scss-module__P0ZRga__icon",
  "label": "ExpandButton-module-scss-module__P0ZRga__label",
});
